import { Component, Input, Output, EventEmitter } from '@angular/core';
import { LanguageManagementService } from 'src/service/language-management.service';
import { LocalService, NumericConfig, OtpType, Status } from 'src/service/local.service';
import { SellerManagementService } from 'src/service/seller-management.service';

@Component({
  selector: 'app-pick-business',
  templateUrl: './pick-business.component.html',
  styleUrl: './pick-business.component.scss'
})
export class PickBusinessComponent {
  OtpType = OtpType;
  lstSectionConfigKeys: string[] = ["seller"];
  @Input() ctryCode: string = '';
  @Output() onBusinessSelected = new EventEmitter();

  contactNumber: number;

  elementIds: any; htmlId: string = ''; isShowOtpPopup = false;

  numericConfig: NumericConfig = { isDecimalAllowed: false } as NumericConfig;

  constructor(public localService: LocalService, private languageManagementService: LanguageManagementService, private sellerManagementService: SellerManagementService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      contact_nbr: 'contact_nbr-' + this.htmlId,
      pick: 'pick-' + this.htmlId
    };
  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
  }

  onAction(index: number) {
    switch (index) {
      case 1: {
        this.isShowOtpPopup = true;
      } break;
    }
  }

  onVerifiedOtp(e: any) {
    this.isShowOtpPopup = false;

    this.sellerManagementService.getBusinessesByContactNumber(this.contactNumber).subscribe(result => {
      if (result.status == Status.Success) {
        this.onBusinessSelected.emit(result.id);
      } else {
        this.localService.showInformationByStatus(result.status);
      }
    });
  }
}
